import { render, staticRenderFns } from "./Wechat.vue?vue&type=template&id=7aabc96c&scoped=true"
import script from "./Wechat.vue?vue&type=script&lang=js"
export * from "./Wechat.vue?vue&type=script&lang=js"
import style0 from "./Wechat.vue?vue&type=style&index=0&id=7aabc96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aabc96c",
  null
  
)

export default component.exports